import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  Validators,
} from '@angular/forms';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { FormStateService } from '../form-state.service';
import { ServiceProviderService } from '../../../../Service/Service-providers/service-provider.service';

@Component({
  selector: 'app-business-details-new',
  templateUrl: './business-details-new.component.html',
  styleUrls: ['./business-details-new.component.scss'],
})
export class BusinessDetailsNewComponent
  implements OnInit, OnDestroy {
  form = new FormGroup({});
  // model: any = {};
  model: any = {
    name: '',
    applicantName: '',
    applicantEmailAddress: '',
    address: '',
    stateId: '',
    countryId: '',
    districtId: '',
    yearOfEstablishment: '',
    gstNumber: '',
    vatNumber: '',
    city: '',
    zip: '',
    addressProof: '',
    certificateOfIncorporation: '',
    galleryIds: '',
    businessTypeId: '',
    averageCustomer: '',
  };
  fields: FormlyFieldConfig[] = [];
  selectedBusinessType!: string;
  @Output() nextSection = new EventEmitter<void>();
  @Input() countryId!: string;
  @Output() clearForm = new EventEmitter<void>();
  @Output() editServiceProviderList: EventEmitter<void> =
    new EventEmitter<void>();
  businessTypes = [];
  receivedObject: any;
  last35Years: { label: string, value: number }[] = [];
  stateId: any;

  constructor(
    private fb: FormBuilder,
    private formStateService1: FormStateService,
    private api: ServiceProviderService,
    private cdr: ChangeDetectorRef
  ) { }
  countryName!: string;

  ngOnInit() {
    this.loadFormData();

    // last 35 ears as option for year of commecement
    const currentYear = new Date().getFullYear();
    this.last35Years = Array.from({ length: 35 }, (_, i) => {
      const year = currentYear - i;
      return { label: year.toString(), value: year };
    });

    const userDetailsString = localStorage.getItem('user');
    if (userDetailsString) {
      const userDetails = JSON.parse(userDetailsString);
      this.countryId = userDetails.country?.countryId;
      this.countryName = userDetails.country?.name;

      if (this.countryId) {
        console.log('CountryId from localStorage:', this.countryId);
        this.model.countryId = this.countryId;
        this.initializeFields();
        this.form.patchValue({ countryId: this.countryId });
      }
    }
    // Subscribe to the selected business type from the FormStateService
    this.formStateService1.selectedBusinessType$.subscribe(
      (businessType: any) => {
        if (businessType) {
          this.selectedBusinessType = businessType;
          this.form.patchValue({
            businessTypeId: businessType.businessTypeId,
          });

          this.model.businessTypeId = businessType.businessTypeId;
        }
      }
    );
    this.api.getBusinessTypeList('').subscribe((businessTypes: any) => {
      this.businessTypes = businessTypes || [];
      this.formStateService1.setBusinessTypes(businessTypes);
      this.initializeFields();
    });
  }

  ngOnDestroy() {
    this.saveFormData();
  }

  initializeFields() {
    console.log('Formly fields initialized')
    const businessTypeOptions = (this.businessTypes || []).map((x: any) => ({
      value: x.businessTypeId,
      label: x.name,
    }
    )
    );
    this.fields = [
      {
        className: 'field col-12',
        template: '<h3>Basics</h3>',
      },
      {
        fieldGroupClassName: 'p-fluid p-formgrid p-grid',
        fieldGroup: [
          {
            fieldGroupClassName: 'field grid p-fluid',
            fieldGroup: [
              {
                className: 'field col',
                type: 'input',
                key: 'name',
                templateOptions: {
                  label: 'Name of the Business',
                  placeholder: 'Enter Name',
                  required: true,
                  hideRequiredMarker: true,
                  pattern: '^[a-zA-Z][a-zA-Z\\s\\-\\.]*$',

                },
                validation: {
                  messages: {
                    pattern: 'Name must contain only letters and spaces',
                  }
                },
                modelOptions: {
                  updateOn: 'change'
                }
              },
              {
                className: 'field col',
                key: 'yearOfEstablishment',
                type: 'select',
                templateOptions: {
                  placeholder: 'Select Year of Commencement',
                  label: 'Year of Commencement',
                  required: true,
                  hideRequiredMarker: true,
                  options: this.last35Years,
                },
                defaultValue: '',
              },
            ],
          },
          {
            template: `<div class="mt-3"></div>`,
          },
          {
            fieldGroupClassName: 'field grid p-fluid',
            fieldGroup: [
              {
                className: 'field col',
                key: 'businessTypeId',
                type: 'select',
                templateOptions: {
                  label: 'Business Type',
                  placeholder: 'Select Business Type',
                  options: businessTypeOptions,
                  required: true,
                  hideRequiredMarker: true,
                },
                hooks: {
                  onInit: (field) => {
                    field.formControl?.valueChanges.subscribe((value: any) => {
                      this.onBusinessTypeChange(value);
                    });
                  },
                },
              },
              {
                className: 'field col',
                key: 'averageCustomer',
                type: 'select',
                props: {
                  placeholder: 'Select Average Customers',
                  label: 'Average Customers',
                  required: true,
                  hideRequiredMarker: true,
                  options: [
                    { label: '0-100', value: '0-100' },
                    { label: '100-500', value: '100-500' },
                    { label: '500-1000', value: '500-1000' },
                    { label: 'More than 1000', value: 'More than 1000' },
                  ],
                },
              },
            ],
          },
          {
            template: `<div class="mt-1"></div>`,
          },
          {
            className: 'field col-12',
            template: '<h3>Address</h3>',
          },
          {
            fieldGroupClassName: 'field grid p-fluid',
            fieldGroup: [
              {
                className: 'field col',
                key: 'countryId',
                type: 'select',
                templateOptions: {
                  disabled: true,
                  options: this.api.getCountry(''),
                  placeholder: 'Select a Country',
                  valueProp: 'countryId',
                  labelProp: 'name',
                  label: 'Country',
                  hideRequiredMarker: true,
                },
                hooks: {
                  onInit: (field) => {
                    if (this.countryId) {
                      field.formControl?.setValue(this.countryId);
                      field.templateOptions!.disabled = true;
                    }
                  },
                },
              },
              {
                className: 'field col',
                key: 'stateId',
                type: 'select',
                templateOptions: {
                  placeholder: 'Select State',
                  options: [],
                  valueProp: 'stateId',
                  labelProp: 'name',
                  label: 'State',
                  required: true,
                  hideRequiredMarker: true,
                },
                hooks: {
                  onInit: (field) => {
                    // Fetch states when initializing
                    this.api.getStatesByCountry(this.countryId).subscribe(states => {
                      field.templateOptions!.options = states;
                    });

                    // Set a listener for value changes
                    field.formControl?.valueChanges.subscribe((selectedStateId: number) => {
                      this.stateId = selectedStateId;

                      // Now fetch districts using selected stateId
                      const districtField = this.findFieldByKey(this.fields, 'districtId');
                      if (districtField) {
                        this.api.getDistrictsByStates(selectedStateId).subscribe(districts => {
                          districtField.templateOptions!.options = districts;
                          this.cdr.markForCheck();
                        });
                      }
                    });
                  }
                }
              }
            ],
          },
          {
            template: `<div class="mt-1"></div>`,
          },
          {
            fieldGroupClassName: 'field grid p-fluid',
            fieldGroup: [
              {
                className: 'field col',
                key: 'city',
                type: 'input',
                templateOptions: {
                  label: 'City',
                  placeholder: 'Enter City',
                  required: true,
                  //hideLabel: true,
                  hideRequiredMarker: true,
                },
              },
              {
                className: 'field col',
                key: 'districtId',
                type: 'select',
                templateOptions: {
                  placeholder: 'Select district',
                  options: [], // Leave empty initially
                  valueProp: 'districtId',
                  labelProp: 'name',
                  label: 'District',
                  required: true,
                  hideRequiredMarker: true,
                },
              }

            ],
          },
          {
            fieldGroupClassName: 'field grid p-fluid',
            fieldGroup: [
              {
                className: 'field col',
                key: 'address',
                type: 'input',
                templateOptions: {
                  label: 'Address',
                  placeholder: 'Enter Address',
                  required: true,
                  //hideLabel: true,
                  hideRequiredMarker: true,
                  disabled: true,
                },
              },
              {
                className: 'field col',
                key: 'zip',
                type: 'input',
                templateOptions: {
                  label: 'Pincode',
                  placeholder: 'Enter Pin Code',
                  required: true,
                  //hideLabel: true,
                  hideRequiredMarker: true,
                },
                validators: {
                  zip: {
                    expression: (c: AbstractControl) =>
                      /^[1-9][0-9]{5}$/.test(c.value),
                    message: (error: any, field: FormlyFieldConfig) =>
                      `${field.formControl?.value} is not a valid ZIP code`,
                  },
                },
              },

            ],
          },
          {
            template: `<div class="mt-3"></div>`,
          },
          {
            // documenttype = addressproof
            key: 'addressProof',
            type: 'file',
            templateOptions: {
              accept: '.pdf,.doc,.docx,.png,.jpg',
              placeholder: 'Upload Address Proof',
              required: true,
              fileSourceId: 1,
            },
            validation: {
              messages: {
                required: () => 'Please select a file',
              },
            },
            validators: {
              validation: [Validators.required],
            },
          },
          // {
          //   template: `<div class="mt-3"></div>`,
          // },
          {
            className: 'field col-12',
            template: '<h3 class="mt-5">Others</h3>',
          },
          {
            type: 'input',
            key: 'gstNumber',
            templateOptions: {
              label: 'GST Number',
              placeholder: 'Enter GST Number',
              required: true,
              hideRequiredMarker: true,
            },
            expressions: {
              hide: 'model.countryId!==1',
            },
            validators: {
              gst: {
                expression: (c: AbstractControl) =>
                  /^[0-9]{2}[a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}[1-9A-Za-z]{1}[Z]{1}[0-9a-zA-Z]{1}$/.test(
                    c.value
                  ),
                message: (error: any, field: FormlyFieldConfig) =>
                  `${field.formControl?.value} is not a valid GST Number`,
              },
            },
          },
          {
            type: 'input',
            key: 'vatNumber',
            templateOptions: {
              label: 'VAT Number',
              placeholder: 'Enter VAT Number',
              required: true,
              hideRequiredMarker: true,
            },
            expressions: {
              hide: 'model.countryId!==2',
            },
            validators: {
              vat: {
                expression: (c: AbstractControl) => /^\d{15}$/.test(c.value),
                message: (error: any, field: FormlyFieldConfig) =>
                  `${field.formControl?.value} is not a valid VAT Number`,
              },
            },
          },
          {
            template: `<div class="mt-2"></div>`,
          },
          {
            template: `<div class="mt-6 mb-3"><strong>Front view photo of business/shop</strong></div>`,
          },
          {
            key: 'galleryIds',
            type: 'multifile',
            templateOptions: {
              placeholder: 'Upload',
              required: true,
              fileSourceId: 1,
              accept: "image/png, image/jpeg"
            },
          },
          {
            template: `<div class="mt-3 mb-3"><strong>Certificate of incorporation</strong></div>`,
          },
          {
            template: `<div class="mt-3"></div>`,
          },
          {
            key: 'commercialRegistrationNumber',
            type: 'input',
            templateOptions: {
              placeholder: 'Enter Commercial Registration Number',
              required: true,
              hideRequiredMarker: true,
            },
            expressions: {
              hide: 'model.countryId!==2',
            },
          },
          {
            template: `<div class="mt-3"></div>`,
          },
          {
            // dType = certificateofincorporation
            key: 'certificateOfIncorporation',
            type: 'file',
            templateOptions: {
              placeholder: 'Upload',
              required: true,
              fileSourceId: 1,
            },
            validation: {
              messages: {
                required: () => 'Please select a file',
              },
            },
          },
          {
            template: `<div class="mt-6"><strong>Application submitted by</strong></div>`,
          },
          {
            fieldGroupClassName: 'field grid p-fluid mt-3',
            fieldGroup: [
              {
                className: 'field col mt-2',
                key: 'applicantName',
                type: 'input',
                templateOptions: {
                  label: 'Name',
                  placeholder: 'Enter Name',
                  required: true,
                  hideRequiredMarker: true,
                },
              },
              {
                className: 'field col mt-2',
                key: 'applicantEmailAddress',
                type: 'input',
                templateOptions: {
                  label: 'Email',
                  placeholder: 'Enter Email',
                  required: true,
                  hideRequiredMarker: true,
                },
                validators: {
                  email: {
                    expression: (c: AbstractControl) =>
                      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(
                        c.value
                      ),
                    message: (error: any, field: FormlyFieldConfig) =>
                      `${field.formControl?.value} is not a valid Email Address`,
                  },
                },
              },
            ],
          },
        ],
      },
    ];
  }

  updateStateOptions(country: string) {
    const stateField = this.findFieldByKey(this.fields, 'stateId');
    if (stateField) {
      this.api.getStates(country).subscribe((states: any) => {
        if (stateField.templateOptions) {
          stateField.templateOptions.options = states;
          console.log('Updated States:', states); // Debug log
        }
      });
    }
  }

  onCountryChange(event: any) {
    const country = event.value;
    this.updateFieldsVisibility(country);

    const stateField = this.findFieldByKey(this.fields, 'stateId');
    if (stateField) {
      if (country) {
        stateField.templateOptions!.disabled = false;
        this.updateStateOptions(country);
      }
    }
  }

  updateFieldsVisibility(country: string) {
    console.log('Current countryId:', country);

    const gstNumberField = this.findFieldByKey(this.fields, 'gstNumber');
    const vatNumberField = this.findFieldByKey(this.fields, 'vatNumber');
    const commercialRegField = this.findFieldByKey(
      this.fields,
      'commercialRegistrationNumber'
    );
    const certificateField = this.findFieldByKey(
      this.fields,
      'certificateOfIncorporation'
    );

    if (gstNumberField) {
      gstNumberField.hideExpression = () => country !== '1'; // Show GST field if country is India ('1')
    }
    if (vatNumberField) {
      vatNumberField.hideExpression = () => country !== '2'; // Show VAT field if country is Oman ('2')
    }
    if (commercialRegField) {
      commercialRegField.hideExpression = () => country !== '2';
    }
    if (certificateField) {
      certificateField.hideExpression = () => country !== '2';
    }
  }

  findFieldByKey(
    fields: FormlyFieldConfig[],
    key: string
  ): FormlyFieldConfig | null {
    for (const field of fields) {
      if (field.key === key) {
        return field;
      }
      if (field.fieldGroup && field.fieldGroup.length > 0) {
        const nestedField = this.findFieldByKey(
          field.fieldGroup as FormlyFieldConfig[],
          key
        );
        if (nestedField) {
          return nestedField;
        }
      }
    }
    return null;
  }

  loadFormData() {
    const savedData = this.formStateService1.getFormData('business-details');
    if (savedData) {
      console.log('Saved Data:', savedData);
      this.model = savedData;
      this.form.patchValue(savedData);
    }

    const mapLocationData = this.formStateService1.getFormData('map-location');
    if (mapLocationData?.address) {
      this.model.address = mapLocationData.address;
      this.form.patchValue({ address: mapLocationData.address });
    }
  }

  clearFormData() {
    this.formStateService1.clearFormData();
    this.form.reset();
    this.model = {};
    this.initializeFields();
    console.log('BusinessDetailsNewComponent: Form data cleared.');
  }
  resetForm() {
    this.form.reset();
    this.model = {};
    this.initializeFields();
  }

  saveFormData() {
    const formData = { ...this.model };
    this.formStateService1.setFormData('business-details', formData);
    console.log(formData);
  }

  onBusinessTypeChange(value: any) {
    const businessTypeField = this.findFieldByKey(
      this.fields,
      'businessTypeId'
    );
    if (businessTypeField) {
      this.api.getBusinessTypeList('').subscribe((businessTypes: any[]) => {
        const selectedType = businessTypes.find(
          (type) => type.businessTypeId === value
        );
        if (selectedType) {
          this.formStateService1.setSelectedBusinessType(selectedType);
        }
      });
    }
  }

  onSubmit() {
    if (this.form.valid) {
      const transformedData = this.transformFormData(this.form.value);
      this.formStateService1.setBusinessDetails(transformedData);
      console.log(transformedData);
      this.nextSection.emit();
      this.cdr.detectChanges();
    }
  }

  transformFormData(formData: any): any {
     const mapLocationData = this.formStateService1.getFormData('map-location');
    const address = formData.address || mapLocationData?.address || '';
    return {
      name: formData.name,
      applicantName: formData.applicantName,
      applicantEmailAddress: formData.applicantEmailAddress,
      address: address,
      stateId: formData.stateId,
      districtId: formData.districtId,
      countryId: this.countryId,
      yearOfEstablishment: formData.yearOfEstablishment,
      gstNumber: formData.gstNumber || null,
      vatNumber: formData.vatNumber || null,
      city: formData.city,
      zip: formData.zip,
      averageCustomer: formData.averageCustomer,
      documents: [
        {
          documentTypeId: 5,
          documentNumber: '',
          fileId: formData.addressProof,
        },
        {
          documentTypeId: 6,
          documentNumber: '',
          fileId: formData.certificateOfIncorporation,
        },
      ],
      galleryIds: formData.galleryIds,
      businessTypeId: formData.businessTypeId,
      serviceProviderTypeId: 0,
      serviceProviderSubTypeId: 0
    };
  }

 populateFormWithServiceProviderDetails(res: any) {
  const mapLocationData = this.formStateService1.getFormData('map-location');
  const address = mapLocationData?.address || res.address || '';
  this.model = {
    name: res.name || '',
    applicantName: res.applicantName || '',
    applicantEmailAddress: res.applicantEmailAddress || '',
    address: address,
    stateId: res.state?.stateId || '',
    countryId: res.country?.countryId || '',
    yearOfEstablishment: +res.yearOfEstablishment,
    gstNumber: res.gstNumber || '',
    vatNumber: res.vatNumber || '',
    city: res.city || '',
    zip: res.zip || '',
    averageCustomer: res?.averageCustomer || '',
    businessTypeId: res.businessType?.businessTypeId || '',
    galleryIds: Array.from(
      new Set(res.serviceProviderGalleries?.map((gallery: any) => gallery.fileId))
    ),
    addressProof: res.serviceProviderDocuments?.find(
      (doc: any) => doc.documentTypeId === 5
    )?.fileId,
    certificateOfIncorporation: res.serviceProviderDocuments?.find(
      (doc: any) => doc.documentTypeId === 6
    )?.fileId,
  };

  const stateId = res.state?.stateId || '';
  const districtId = res.district?.districtId || '';

  this.form.patchValue(this.model); // patch everything except districtId

  // Delay district patching until districts are loaded
  this.api.getDistrictsByStates(stateId).subscribe((districts) => {
    const districtField = this.findFieldByKey(this.fields, 'districtId');
    if (districtField) {
      districtField.templateOptions!.options = districts;
      this.form.patchValue({ districtId: districtId });
    }
    this.cdr.detectChanges();
  });

  this.initializeFields();
  this.formStateService1.setFormData('business-details', this.model);
}

}
